class AyumeGuideMedia extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const {signal}=this.abort;
  this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.manualPaused=false;this.manualPlay=false;this.visible=false;
  this.video=this.querySelector('[data-guide-video]');this.gif=this.querySelector('[data-guide-gif]');this.button=this.querySelector('[data-video-toggle],[data-gif-toggle]');
  if(!this.button)return;
  this.button.addEventListener('click',()=>{const playing=this.video?!this.video.paused:!this.gif.hidden;this.manualPaused=playing;this.manualPlay=!playing;this.sync(true);},{signal});
  this.video?.addEventListener('playing',()=>{this.classList.add('is-playing','has-played');this.label(false);},{signal});
  this.video?.addEventListener('pause',()=>{this.classList.remove('is-playing');this.label(true);},{signal});
  this.video?.addEventListener('ended',()=>{if(this.hasAttribute('data-play-once')){this.manualPaused=true;this.classList.remove('is-playing');this.label(true);}},{signal});
  this.video?.addEventListener('error',()=>{this.classList.remove('has-played','is-playing');this.label(true);},{signal});
  const sound=this.querySelector('[data-audio-toggle]');
  sound?.addEventListener('click',()=>{this.video.muted=!this.video.muted;sound.textContent=this.video.muted?sound.dataset.on:sound.dataset.off;sound.setAttribute('aria-pressed',String(!this.video.muted));},{signal});
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.15});this.observer.observe(this);
  document.addEventListener('visibilitychange',()=>this.sync(),{signal});
  this.reduced.addEventListener('change',()=>{this.manualPlay=false;this.sync();},{signal});
 }
 label(paused){this.button.textContent=paused?this.button.dataset.play:this.button.dataset.pause;this.button.setAttribute('aria-pressed',String(paused));}
 sync(fromButton=false){
  const play=!document.hidden&&this.visible&&!this.manualPaused&&(!this.reduced.matches||this.manualPlay);
  if(this.video){
   if(!play){this.video.pause();if(this.reduced.matches&&!this.manualPlay)this.classList.remove('has-played');this.label(true);return;}
   if(!this.video.src)this.video.src=this.video.dataset.src;
   // Use the play promise: Safari may reject autoplay in low-power mode.
   // A visible Play button always provides the user gesture fallback.
   this.video.play().catch(()=>{this.label(true);if(fromButton)this.manualPlay=false;});
  }else if(this.gif){
   if(play&&!this.gif.src)this.gif.src=this.gif.dataset.src;
   this.gif.hidden=!play;this.label(!play);
  }
 }
 disconnectedCallback(){this.video?.pause();this.abort?.abort();this.abort=null;this.observer?.disconnect();}
}
if(!customElements.get('ayume-guide-media'))customElements.define('ayume-guide-media',AyumeGuideMedia);
